import React from 'react';
import { useState, useEffect, useFormContext, Hooks, Code, Form, Field, Name, Title, Info, Actions, Toast, API, Utility, Button, Files, Control, Messages, OptionType } from 'helpers/FormImports';
import { Claim } from 'models/ClaimModel';
import { MultiSelectList, SingleSelectList } from 'components/common/MultiSelectList';
import { Billing } from 'models/BillingModel';
import { ClaimHelper } from 'helpers/forms/ClaimHelpers';
import { Extract } from 'helpers/ExtractHelper';

const ClaimForm: React.FC = () => {
  const width = { sno: 12, hsc: 8, diag: 8, client: 16, doctor: 16, status: 15, date: 15, amount: 8 };
  const [formId, formName] = [Code.Form.Id.CLAIM, Code.Form.Name.CLAIM];
  const {keyId, activeId, setActiveId, loading, setLoading, message, setMessage, showMenu, setShowMenu, confirm, setConfirm, error, setError, menuPosition, setMenuPosition, contextMenuRef, iframeRef, formRef } = useFormContext();
  const [activeTab, setActiveTab] = useState<string>(Utility.Storage.GetTab(formName));
  const [formData, setFormData] = useState<Claim>({});
  const [doctorOptions, setDoctorOptions] = Hooks.Form.Options();
  const [statusOptions, setStatusOptions] = Hooks.Form.Options();
  const [billingList, setBillingList] = useState<Billing[]>([]); 
  const [exportData, setExportData] = useState<Billing[]>([]); 
  const [doctorId, setDoctorId] = useState<number>(1);
  const [statusId, setStatusId] = useState<number>(Code.Option.Billing.TOSUBMIT);
  const [selectAllChecked, setSelectAllChecked] = useState<boolean>(false);
  const [selectedItems, setSelectedItems] = useState<string[]>([]);
  const [hasKeyId, setHasKeyId] = useState<boolean>(false);
  const [submitterPrefix, setSubmitterPrefix] = useState<string>('');
  
  Form.Click.Outside([contextMenuRef],[() => setShowMenu(false),() => {}],true);
  const Privilege = Hooks.Privilege.List(formId);
  Hooks.Privilege.HasOpen(Privilege);
  
  useEffect(() => {
    Files.Json.API(Code.File.DOCTOR, Code.Option.Common.ALL, setDoctorOptions, setError);
    Files.Json.Http(Code.File.CLAIM+Code.File.STATUS, Code.Option.Common.ALL, setStatusOptions, setError);
    
    API.Data.GetByKeyId<Claim>(formName, keyId, setLoading, setError)
      .then(async(data) => { if(data) {
        setActiveId(data.claim_active); 
        const formData = await Form.Map.Data(data);
        setFormData((prevData) => ({
          ...prevData,
          ...formData,
        }));
        //setSelectedItems(JSON.parse(data.bill_list)); 
        setHasKeyId(true);
        setStatusId(Code.Option.Common.ALL)
        callBillingList(data.claim_id);
      }})
      setLoading(false);
  }, []);

  useEffect(() => {
    if(keyId === Code.Key.NEW) {
      callBillingList(0);
      setSelectedItems([]);
      setSelectAllChecked(false);
    }
  }, [statusId, doctorId]);

  useEffect(() => {
    console.log("Form Data Updated:", formData);
  }, [formData]);

  const callBillingList = async (claimId: number | undefined) => {
      const url = API.Build.FormApiEndpint(Code.Form.Name.BILLING, 100, Name.Billing.Id, Code.Option.Sort.DESC, {
        fields: Utility.Join.Fields([
          Name.Billing.Id, 
          Name.Billing.Number, 
          Name.Billing.HscName, 
          Name.Billing.Diagnosis1Name, 
          Name.Client.FullName, 
          Name.Doctor.FullName, 
          Name.Common.StatusName, 
          Name.Billing.BillingDate, 
          Name.Billing.Amount,
          Name.Doctor.Id
        ]), 
        ...(claimId === 0 && { 
          [Name.Doctor.Id]: doctorId, 
          [Name.Common.StatusId]: statusId
        }),
        ...(claimId !== 0 && { 
          [Name.Claim.Id]: claimId 
        }),
       });
      //console.log("Billing List URL:", url);
      await API.Data.List<Billing>(url, setBillingList, setError, setLoading);
   };

  const onSubmit = async (e: React.FormEvent) => {
    if (!Toast.Validate.Form(e,setMessage)) return;
    if (keyId === Code.Key.NEW && selectedItems.length === 0) { 
      Utility.Message.Warning(["Select one or more bills"],setMessage);
      return;
    }
    const addonData = await API.Data.AddonData(formData, formName, keyId);
    const finalData = Utility.Sanitize.FormData({
      ...formData,
      ...addonData,
      ...(keyId === Code.Key.NEW && {
        claim_count: selectedItems.length,
        bill_list: JSON.stringify(Array.from(selectedItems))
      })
    });

    const response = await API.Data.Save(formName, keyId, finalData, setMessage, true);
    if(response){
      //do nothing
    }

    // if (keyId === Code.Key.NEW) {
    //   const response = await API.Data.Save(formName, keyId, finalData, setMessage, true, Code.Form.PopupClose.NONE);
    //   if(response.data){
    //     console.log("Claim response:", response.data);
    //     const newid =  Extract.Key.Decode(response.data?.newid);
    //     if(newid > 0) {
    //       for (const BillingId of selectedItems) {
    //         const billData: Billing = {
    //           billing_id: Number(BillingId),
    //           status_id: Code.Option.Billing.INPROCESS,
    //           claim_id: newid,
    //           claim_date: finalData.claim_date,
    //         };

    //         await API.Data.Save(Code.Form.Name.BILLING, BillingId, billData, setMessage, false, Code.Form.PopupClose.NONE);
    //       }
    //       Utility.Button.PopupClose();
    //     }
    //   }
    // }
    // else
    // {
    //   API.Data.Save(formName, keyId, finalData, setMessage);
    // }
  };
  
  const callFullBillingList = async (claimId: number) => {
      const url = API.Build.FormApiEndpint(Code.Form.Name.BILLING, 100, Name.Billing.Id, Code.Option.Sort.DESC, {
        fields: Utility.Join.Fields([
          Name.Billing.Id, 
          Name.Billing.BillingDate, 
          Name.Billing.ClaimDate, 
          Name.Billing.Sequence, 
          Name.Billing.HscName, 
          Name.Billing.Diagnosis1Name, 
          Name.Billing.Modifier1, 
          Name.Billing.Modifier2, 
          Name.Billing.Modifier3, 
          Name.Billing.Number, 
          Name.Billing.Amount,
          Name.Doctor.Id,
          Name.Doctor.PractitionerCode,
          Name.Doctor.ShortCode,
          Name.Doctor.FirstName,
          Name.Doctor.FacilityNumber,
          Name.Doctor.FunctionalCentre,
          Name.Doctor.BusinessArrangement,
          Name.Doctor.PayToCode,
          Name.Doctor.PayToULI,
          Name.Client.HealthCard,
        ]), 
        [Name.Claim.Id]: claimId
       });

       console.log("Full Billing List URL:", url);

      await API.Data.List<Billing>(url, setExportData, setError, setLoading);
   };
   

  useEffect(() => {
    if(exportData.length > 0) {

      console.log("Export Data Updated:", exportData);
   
      if (!formData) {
        Utility.Message.Error(["No Claim data found"],setMessage);
        return;
      }

      if(submitterPrefix==='') {
        Utility.Message.Error(["Submitter code incorrect"],setMessage); 
        return;  
      }
       
      const FileNo = formData.claim_serial?.toString() || ''; // Clm001028
      const FileName = formData.claim_number || ''; // Clm001028
      const Records = exportData.length; //number of records

      console.log("exportData---->", exportData);

      let content:string ='';
      //content += ClaimHelper.Dashes(254);
      //content += '\n'; // New line
      content += ClaimHelper.Header(submitterPrefix, FileNo);
      exportData.map((item) => {
        const BillingDate = item.billing_date; 
        const DoctorCode = item.doctor_short_code; //LB
        const Sequence = item.billing_sequence || item.billing_id; //11235
        const ActionCode = item.billing_action; //A
        const PractitionerId = item.doctor_practitioner_code; //723183308
        const HealthCardNo = item.client_health_card; //667219161 Personal Health Number
        const HSCCode = item.billing_hsc_name; //B900
        const DiagnosticCode = item.billing_diagnosis1_name; //361.3
        const Modifier1 = item.billing_modifier1; //NEWEP/OPHTCO
        const Modifier2 = item.billing_modifier2; //NEWEP/OPHTCO
        const Modifier3 = item.billing_modifier3; //NEWEP/OPHTCO
        const FacilityNumber = item.doctor_facility_number; //873320
        const FunctionalCentre = item.doctor_functional_centre; //EXRM
        const BusinessArrangement = item.doctor_business_arrangement; //4509121
        const PayToCode = item.doctor_pay_to_code; //BAPY
        const PayToULI = item.doctor_pay_to_uli; //723183308
        const BillingNumber = item.billing_number; //000895C
        const Amount = item.billing_amount; //51.29
        content += ClaimHelper.Row(submitterPrefix,BillingDate,DoctorCode,Sequence,ActionCode,PractitionerId,HealthCardNo,HSCCode,DiagnosticCode,Modifier1,Modifier2,Modifier3,FacilityNumber,FunctionalCentre,BusinessArrangement,PayToCode,PayToULI,BillingNumber,Amount);
      });
      content += ClaimHelper.Footer(submitterPrefix, FileNo, Records);

      const blob = new Blob([content], { type: 'application/octet-stream' });
      ClaimHelper.download(blob, FileName);
  }
      
    
  }, [exportData]);

  

  const DownloadClaimFile = async () => {
    if(billingList && billingList.length > 0) {

      var doctorId = billingList[0].doctor_id || 0;
      if(doctorId && doctorId>0) {

        const doctor = await API.Data.GetDoctorSubmitter(doctorId);
        if(doctor){
          var SubmitterPrefix =  doctor?.submitter_prefix ?? '';

          if(SubmitterPrefix!=='') {
            setSubmitterPrefix(SubmitterPrefix);
          }  
        }
        
      }

      
    }
      
    if(formData) {
      const claimId = formData.claim_id;
      if(claimId && claimId>0) {
        await callFullBillingList(claimId);
      }      
    }
  }

  return (
    <Control.Form.Frame setMenuPosition={setMenuPosition} setShowMenu={setShowMenu}>
      <Messages.Toast Messages={message} Error={error} />
      <Messages.Confirm Messages={confirm} onConfirm={() => API.Data.Delete(formName, keyId, activeId, setMessage)} onRefuse={()=>{}} />
      {!loading && (
        <form id={Code.Form.Name.EDIT} ref={formRef} onSubmit={onSubmit} autoComplete="off">
          <Button.Save keyId={keyId} activeId={activeId} handleDelete={() => Toast.Delete.CurrentRecord(activeId, setConfirm)}  formName={formName} Privilege={Privilege} title={`#${formData.claim_number?.toUpperCase()} &nbsp; &nbsp; &nbsp; Total: ${formData.claim_count} bills`} />
          <Control.Tab.Header titles={["Details"]} activeTab={activeTab} formName={formName} setActiveTab={setActiveTab} />
          <Control.Form.Data>
 
            <Control.Tab.Content id={Code.Tab.Tab1} isActive={activeTab === Code.Tab.Tab1}>
              <Control.Row>
                <Field.Title  size={[0,40,0]} />
                <Field.Date id={Name.Claim.Date} value={formData.claim_date} title={Title.Date} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,20,1]} currentDate={true} />
                <Field.Select id={Name.Common.StatusId} value={statusId} title={Title.State} options={statusOptions} onChange={(e) => setStatusId(Form.Field.Value(e))} size={[1,20,1]} disabled={true} />
                <Field.Select id={Name.Doctor.Id} value={doctorId} title={Title.Doctor} options={doctorOptions} onChange={(e) => setDoctorId(Form.Field.Value(e))} size={[1,20,0]} disabled={hasKeyId} />
              </Control.Row>
              <Control.Form.Table>
                <Control.Form.Title>
                  <Control.SelectAll selectAllChecked={selectAllChecked} onSelectAll={(e) => Form.Select.AllIds(e, setSelectedItems, billingList, setSelectAllChecked,Code.Form.Name.BILLING)} extra={0} />
                  <Control.Form.Columns values={[
                    [Title.SNo, width.sno],
                    [Title.HSC, width.hsc],
                    [Title.Diag, width.diag],
                    [Title.Client, width.client],
                    [Title.Doctor, width.doctor],
                    [Title.State, width.status],
                    [Title.Date, width.date],
                    [Title.Amount, width.amount, Code.Align.RIGHT]
                  ]} />
                </Control.Form.Title>
                <Control.Form.List>
                  {billingList.map((item, index) => { return (
                    <Control.Form.Index key={index} index={index}>
                      <Control.Form.Item>
                        <Control.Grid.Check keyId={item.billing_id?.toString()} selectedItems={selectedItems} toggleSelection={Form.Select.Toggle} setSelectedItems={setSelectedItems} />
                        <Control.Grid.Items values={[
                          [item.billing_number, width.sno],
                          [item.billing_hsc_name, width.hsc],
                          [item.billing_diagnosis1_name, width.diag],
                          [Utility.Get.FullName(item, Code.Form.Name.CLIENT), width.client],
                          [Utility.Get.FullName(item, Code.Form.Name.DOCTOR), width.doctor],
                          [item.status_name, width.status],
                          [Utility.Format.DateOnly(item.billing_date), width.date],
                          [Utility.Format.Amount(item.billing_amount), width.amount, Code.Align.RIGHT],
                        ]} />
                      </Control.Form.Item>
                    </Control.Form.Index>
                  )})}
                </Control.Form.List>
              </Control.Form.Table>
              <Control.Row>
                <Field.Area id={Name.Claim.Comment} value={formData.claim_comment} title={Title.Comment} onChange={(e) => Form.Field.Change(e, formData, setFormData)} />
              </Control.Row>
              <Control.Box>
                <Button.Action onClick={() => DownloadClaimFile()} title='Download Claim File' />
              </Control.Box>
            </Control.Tab.Content>
          </Control.Form.Data>
        </form>
      )}
      {showMenu && (<div ref={contextMenuRef}><Control.FormContextMenu keyId={keyId} activeId={activeId} showMenu={showMenu} formName={formName}  handleDelete={() => Toast.Delete.CurrentRecord(activeId, setConfirm)} setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition} /></div>)}
      <Actions.Form />
    </Control.Form.Frame>
  );
};

export default ClaimForm;